import { BaseModel } from '~/models/baseModel';

export class GroupExtensionModel extends BaseModel {
    public allowBroker:boolean;
    public allowBuyer:boolean;
    public allowClasser:boolean;
    public allowContractor:boolean;
    public allowGrower:boolean;
    public isOpen:boolean;
}